import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AppSettings, Storage } from '../../configs'

import { logoutAction } from '../../redux/actions/UserAction'
import { ClearMasterAction } from '../../redux/actions/MasterAction'
import { setNotActivePOAction } from '../../redux/actions/DocControlAction'
import Avatar from '@material-ui/core/Avatar';

const initial_hamberger_status = {
    aria_expanded: false,
    class: 'collapsed',
    collapsed: 'collapse',
};

class HeaderTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hamberger_status: initial_hamberger_status,
            isExpand : this.props.isExpand === undefined || this.props.isExpand=== 'Y',
            ShowButton : this.props.isExpand === undefined || this.props.isExpand=== 'Y',
            visibled : this.props.visibled === undefined || this.props.visibled=== true,
        };
        this.handleCollapse = this.handleCollapse.bind(this)
    }

    handleCollapse() {
        window.$('#collapseItemOverview'+this.props.id).toggleClass('show');
        window.$('#collapseItemOverview'+this.props.id).focus();
        const {isExpand} = this.state;
        this.setState({...this.state,isExpand:!isExpand});

    }

    render() {
        // const today = new Date();
        // const roleAdmin = Storage.getRoleAdmin()
        // const role = Storage.getRole()

        const {isExpand,visibled} = this.state
        return (
         visibled && (   <div  >
        <div className="sp-page-wrapper" >
            <div className="sp-table-container">
                        <div className="showhide-detail-button">
                        <a onClick={this.handleCollapse}
                            className="btn-showhide-detail2"
                            data-toggle="collapse"
                            href="#main"
                            role="button"
                            aria-expanded="false"
                            aria-controls={"collapseItemOverview"+this.props.id}
                            style={{display:'block'}}
                            >
                            <i className={"icon icon-circle-" + (isExpand===true ? "up":"down")} /><span>{this.props.tableName}</span> {this.props.element}
                        </a>
                        
                        {/* <a class="btn btn-primary" data-toggle="collapse" href={"#collapseItemOverview"+this.props.id} role="button" aria-expanded="false" aria-controls="multiCollapseExample1">{this.props.tableName}</a> */}
                        </div>
            </div>
        </div>
                <div className={isExpand===true ? "collapse collapse-onlinereviewer2 show" : "collapse collapse-onlinereviewer2" } id={"collapseItemOverview"+this.props.id} >
                                {this.props.children}
                </div> 
    </div>
         )
        )
    }
}


export default connect(
)(HeaderTable);
